const MONTHLY_DEMINIMIS_ALLOWANCES = 2000

export { MONTHLY_DEMINIMIS_ALLOWANCES }
